import _ from 'lodash';

import * as BECaller from '../../util/apiCaller';
import { setError, setSuccessMessage } from '../App/ErrorsActions';
import urlHelper from '../../util/url';

export const USERS = 'PERMISSIONS_USERS',
  LOADING = 'PERMISSIONS_LOADING';

let options = {};

export function error(err) {
  return setError(err);
}

export function getUsers(opt = {}) {
  if (!_.isEmpty(opt)) {
    options = opt;
  }

  return dispatch => {
    dispatch({
      type: LOADING,
      val: true
    });

    let url = 'users';
    url += urlHelper.buildQuery(options);

    BECaller.api(url, 'get').then(
      data => {
        dispatch({
          type: USERS,
          data
        });
      },
      err => {
        dispatch(setError(err));
      }
    );
  };
}

export function saveUsers(body) {
  return dispatch => {
    dispatch({
      type: LOADING,
      val: true
    });

    BECaller.api('users/permissions', 'put', body).then(
      () => {
        dispatch(setSuccessMessage('Permissions are updated'));
        return dispatch(getUsers());
      },
      err => {
        dispatch(setError(err));
        dispatch({
          type: LOADING,
          val: false
        });
      }
    );
  };
}
